var map = {
	"./icon_home-act.png": 8823,
	"./icon_home.png": 7719,
	"./icon_recharge-act.png": 4050,
	"./icon_recharge.png": 1998,
	"./icon_service-act.png": 6274,
	"./icon_service.png": 6441,
	"./icon_user-act.png": 7582,
	"./icon_user.png": 4503,
	"./icon_withdraw-act.png": 6798,
	"./icon_withdraw.png": 270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5121;